import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './Button.module.css';
import { ButtonProps, ButtonVariants } from './Button.types';
import LoadingSpinner from './LoadingSpinner/LoadingSpinner';

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = ButtonVariants.Primary,
      label,
      children,
      className,
      isLoading,
      loadingLabel,
      disabled,
      disableOnLoading = true,
      ...props
    },
    ref,
  ) => {
    const text = isLoading && loadingLabel !== undefined ? loadingLabel : children || label;
    return (
      <button
        type="button"
        ref={ref}
        aria-disabled={isLoading || disabled}
        disabled={disableOnLoading ? isLoading || disabled : disabled}
        className={classNames({
          [styles.button]: variant !== ButtonVariants.Text,
          [styles.primary]: variant === ButtonVariants.Primary,
          [styles.secondary]: variant === ButtonVariants.Secondary,
          [styles.textbutton]: variant === ButtonVariants.Text,
          [styles.loadingButton]: isLoading,
          [className!]: className !== undefined,
        })}
        {...props}
      >
        {text}
        {isLoading === true && (
          <LoadingSpinner
            variant={variant === ButtonVariants.Primary ? ButtonVariants.Primary : ButtonVariants.Secondary}
            className={styles.loadingIcon}
          />
        )}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
